import { render, staticRenderFns } from "./DurationInput.vue?vue&type=template&id=2c15fc62"
import script from "./DurationInput.vue?vue&type=script&lang=ts"
export * from "./DurationInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c15fc62')) {
      api.createRecord('2c15fc62', component.options)
    } else {
      api.reload('2c15fc62', component.options)
    }
    module.hot.accept("./DurationInput.vue?vue&type=template&id=2c15fc62", function () {
      api.rerender('2c15fc62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DurationInput.vue"
export default component.exports